import React,{useEffect,useState} from "react";
import tw from "twin.macro";
import styled from "styled-components";
import {Link} from "react-router-dom";
const Footers = tw.div`justify-between items-center flex py-1 mt-20 bg-gray-800 xsm:px-4 lg:px-10`;
const FooterText = tw.h1`text-xs md:text-sm hover:text-gray-300 text-white truncate `;
const Flex = tw.div`lg:flex items-center p-2`;
const FlexLink = tw.div`flex items-center `;
const Img = tw.img`w-3 h-3 lg:w-4 lg:h-4`;

const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block p-2 rounded-full bg-gray-100 text-gray-900 hover:bg-gray-500 transition duration-300 mr-4 last:mr-0`}
  svg {
    ${tw`w-4 h-4`}
  }
`;

function Footer () {

  const [date, setDate] = useState("")

  useEffect(() => {
    var d = new Date();
    setDate(d.getFullYear())
  }, [])
  return (
    <>
      <Footers>
        <Flex>
          <FooterText>Copyright &copy; {date} Flexposter </FooterText>
          <FlexLink>
            <FooterText>  <Link to="contactUs">ContactUs</Link> </FooterText>
            <FooterText> \ </FooterText>
            <FooterText>  <Link to="privacy_policy">Privacy Policy</Link> </FooterText>
            <FooterText> \ </FooterText>
            <FooterText>  <Link to="siteMap"> SiteMap</Link> </FooterText>

          </FlexLink>
        </Flex>
     
        <Flex>
          <SocialLink href="https://www.facebook.com/flexpostersofficial">
            <Img src={require("../images/flximg/facebook.svg")} />
          </SocialLink>
          <SocialLink href="https://twitter.com/flexposters1">
            <Img src={require("../images/flximg/twitter.svg")}/>
          </SocialLink>
        </Flex>
      </Footers>
    </>
  );
}

export default Footer;
